import { TProductSchemaTypes } from '@/api/api.types'

export default function getProductEventEntity(
  product: Pick<TProductSchemaTypes['productSchema'], 'sku' | 'priceInPence'>,
) {
  return {
    domain: 'broadband',
    sku: product.sku,
    fullPrice: product.priceInPence,
    price: product.priceInPence,
  }
}
